import * as angular from 'angular';

export type ShipperUserDtoWithAggregatedState = ShipperUserDto & {
    aggregatedState: string;
};

export class ShipperAdminCurrentUserService {
    public currentShipperUser: ShipperUserDto;

    aggregateState(user: ShipperUserDto): ShipperUserDtoWithAggregatedState {
        (user as ShipperUserDtoWithAggregatedState).aggregatedState = '';
        if (user.states.hasOwnProperty('APPROVED')) {
            (user as ShipperUserDtoWithAggregatedState).aggregatedState =
                'ACTIVE';
        } else if (
            user.states.hasOwnProperty('CANCELED') &&
            !user.states.hasOwnProperty('APPROVED') &&
            !user.states.hasOwnProperty('NOT_APPROVED') &&
            !user.states.hasOwnProperty('PENDING')
        ) {
            (user as ShipperUserDtoWithAggregatedState).aggregatedState =
                'CANCELLED';
        } else if (
            user.states.hasOwnProperty('NOT_APPROVED') &&
            !user.states.hasOwnProperty('APPROVED')
        ) {
            (user as ShipperUserDtoWithAggregatedState).aggregatedState =
                'WAITING';
        } else if (
            user.states.hasOwnProperty('PENDING') &&
            !user.states.hasOwnProperty('APPROVED') &&
            !user.states.hasOwnProperty('NOT_APPROVED') &&
            !user.states.hasOwnProperty('CANCELED')
        ) {
            (user as ShipperUserDtoWithAggregatedState).aggregatedState =
                'PENDING';
        } else if (
            !user.states.hasOwnProperty('PENDING') &&
            !user.states.hasOwnProperty('APPROVED') &&
            !user.states.hasOwnProperty('NOT_APPROVED') &&
            !user.states.hasOwnProperty('CANCELED')
        ) {
            (user as ShipperUserDtoWithAggregatedState).aggregatedState =
                'NONE';
        }

        return user as ShipperUserDtoWithAggregatedState;
    }
}

angular
    .module('app')
    .service('shipperAdminCurrentUserService', ShipperAdminCurrentUserService);
